//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ValidateEachFormChildInFormJson: FeatureFlag = {"Id":"ValidateEachFormChildInFormJson","Label":"(KILL)[10.24]ValidateEachFormChildInFormJson","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When serializing a form to JSON, validate each top-level child immediately before writing it instead of validating the full form up front.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
